import React from 'react';
import { range } from 'lodash';

import BlockPlaceholder from 'components/consumer/BlockPlaceholder';
import TextPlaceholder from 'components/consumer/TextPlaceholder';

const PLACEHOLDER_ITEMS_MOBILE = range(1, 17);

const CollectionsGridMobilePlaceholders = () => (
  <>
    {PLACEHOLDER_ITEMS_MOBILE.map(item => (
      <div key={item}>
        <div className="relative">
          <BlockPlaceholder className="!h-[350px] !w-full" />

          <div className="w-full -bottom-5 absolute">
            <BlockPlaceholder className="!mx-auto !my-0 !h-2 !w-1/5" />
          </div>
        </div>

        <div className="mx-0 my-8 px-4 py-0">
          <div className="text-sm font-bold mb-[.325rem] text-gray">
            <TextPlaceholder className="!w-3/4 !h-5" />
          </div>

          <div className="text-xs text-gray">
            <TextPlaceholder className="!w-full !h-[30px]" />
          </div>
        </div>
      </div>
    ))}
  </>
);

export default CollectionsGridMobilePlaceholders;
